import axios from 'axios'
import router from "@/router"
import { Loading } from 'element-ui'
import { publicFun } from '@/plugins/public';
let loading;

import {
    logout,
    login,
    domain,
    refreshToken
} from "@/service";

function startLoading() { //使用Element loading-start 方法
    loading = Loading.service({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.1)',
        text: '加载中',
    })
}

function endLoading() { //使用Element loading-close 方法
    loading && loading.close()
}
const url = 'http://10.10.3.126:18081/api' // 张玉龙
// const url = 'http://10.10.3.231:18081/api' // 石镜
// const url = 'http://10.10.3.109:18081/api' // 蒋浩林
    // const url = 'http://10.10.3.192:18081/api'  // 程宏业
// const url = 'https://test.d2ssoft.com/gengyun-api' // 测试环境
// const url = 'http://10.6.4.20:18081' // 开发环境
// const url = 'https://test.d2ssoft.com/gengyun-api'

let reqCount = 0;
function addReqCount(){
  // 计数器累加
  // 每一次请求就加1，只要大于1就展示loading
  startLoading();
    reqCount += 1;
}
function subtractReqCount(){
  // 计数器累减
  // 每一次请求结束或者请求失败减1，只要等于0就取消loading
    if (reqCount > 0) {
        reqCount--;
    }
    if(!reqCount){
        endLoading();
    }
}

const instance = axios.create({
    timeout: 120000,
    baseURL: process.env.NODE_ENV == 'development' ? url : process.env.VUE_APP_URL
    // baseURL: url
})
function get(key){//获取cookie方法
    /*获取cookie参数*/
    var getCookie = document.cookie.replace(/[ ]/g,"");  //获取cookie，并且将获得的cookie格式化，去掉空格字符
    var arrCookie = getCookie.split(";")  //将获得的cookie以"分号"为标识 将cookie保存到arrCookie的数组中
    var tips;  //声明变量tips
    for(var i=0;i<arrCookie.length;i++){   //使用for循环查找cookie中的tips变量
        var arr=arrCookie[i].split("=");   //将单条cookie用"等号"为标识，将单条cookie保存为arr数组
        if(key==arr[0]){  //匹配变量名称，其中arr[0]是指的cookie名称，如果该条变量为tips则执行判断语句中的赋值操作
            tips=arr[1];   //将cookie的值赋给变量tips
            break;   //终止for循环遍历
        } 
    }
    return tips;
}

// 添加请求拦截器
instance.interceptors.request.use(function(config) {
    let temp = ['/system/system-menu/update', '/workorder/d2sworkorder/workorderdemand/save', '/user/d2suser/info/save']
    if (temp.includes(config.url)) {
        let obj = config.headers;
        delete obj['Content-Type'];
        // config.headers['Content-Type'] = 'application/json; charset=UTF-8';
        // config.data = JSON.stringify(config.data);
        config.headers['Content-Type'] = 'multipart/form-data';
    } else {
        config.headers['Content-Type'] = 'application/json; charset=UTF-8';
    }
    if (window.sessionStorage.getItem('authorizationToken')) {
        //token字段是要和后端协商好的
        if (window.sessionStorage.getItem('authorizationToken').indexOf('Bearer') != -1) {
            config.headers.common["Authorization"] = window.sessionStorage.getItem('authorizationToken');
        } else {
            config.headers.common["Authorization"] = 'Bearer ' +  window.sessionStorage.getItem('authorizationToken');
        }
    } else if(get('authorizationToken')) {
        let authorizationToken = get('authorizationToken');
        window.sessionStorage.setItem('authorizationToken', 'Bearer ' + authorizationToken);
        window.sessionStorage.setItem('refreshToken', get('refreshToken'))
        config.headers.common["Authorization"] = 'Bearer ' + authorizationToken;
    }
    // 在发送请求之前做些什么
    // startLoading();
    addReqCount();
    return config;

}, function(error) {
    // 对请求错误做些什么
    // endLoading();
    subtractReqCount();
    if (error.message.includes('timeout')) { // 判断请求异常信息中是否含有超时timeout字符串
        publicFun.message('请求超时！', 0);
    }
    publicFun.message('请求失败！', 0);
    return Promise.reject(error);
});

// 添加响应拦截器
instance.interceptors.response.use((response) => {
    // 对响应数据做点什么
    // endLoading();
    subtractReqCount();
    return response.data;

},  async error => {
    // 对响应错误做点什么
    if (error.response.status == 401) { //身份过期/token无效
        // refresh_token刷新一个新的token回来
        // instance.post(
        //     '/auth/jwt/refreshJWT', { refreshToken: localStorage.getItem('refreshToken') }
        // ).then(res => {
        //     // console.log(res);
        //     if (res.code == 0 && res.data) {
        //         localStorage.setItem('token', res.data.token)
        //         localStorage.setItem('refreshToken', res.data.refreshToken)
        //         error.config.headers.Authorization = res.data.token
        //         return instance(error.config)
        //     } else {
        //         router.push('/login')
        //     }
        // })
        let res = await refreshToken({ refreshToken: window.sessionStorage.getItem('refreshToken') });
        if (res.data.code == 0 && res.data.data) {
            subtractReqCount();
            window.sessionStorage.setItem('authorizationToken', 'Bearer ' + res.data.data.token)
            window.sessionStorage.setItem('refreshToken', res.data.data.refreshToken)
            document.cookie = 'authorizationToken=Bearer ' + res.data.data.token + ';domain=' + domain + ';path=/';
            document.cookie = "refreshToken=" + res.data.data.refreshToken + ";domain=" + domain + ";path=/";
            // 重新请求
            error.config.headers.Authorization = 'Bearer ' + res.data.data.token
            return instance(error.config)
        } else {
            subtractReqCount();
            logout();
            // router.push('/login')
        }
    } else {
        // endLoading();
        subtractReqCount();
        publicFun.message('未知异常,请联系管理员!', 2)
        return Promise.reject(error);
    }
    
});


class Request {
    get(url, data) {
        return instance.get(
            url, {
                params: data
            }
        )
    }
    post(url, data) {
        return instance.post(
            url,
            data
        )
    }
}

export {
    Request,
    instance
}